import { Injectable, InjectionToken } from '@angular/core';
import { ProductListReviewItem, ProductListReviewResponseItem } from '@reviews/const';
import { Converter } from '@spartacus/core';

@Injectable({ providedIn: 'root' })
export class ProductListReviewNormalizer implements Converter<ProductListReviewResponseItem, ProductListReviewItem> {
  convert(source: ProductListReviewResponseItem): ProductListReviewItem {
    return { reviewsCount: source.TotalReviewsCount, productCode: source.SKUs, score: source.TotalScore };
  }
}

export const PRODUCT_LIST_REVIEW_NORMALIZER = new InjectionToken<ProductListReviewNormalizer>(
  'ProductListReviewNormalizer',
);
